import { render } from "./KeyPerformanceView.vue?vue&type=template&id=5756b7d4&scoped=true"
import script from "./KeyPerformanceView.vue?vue&type=script&lang=js"
export * from "./KeyPerformanceView.vue?vue&type=script&lang=js"

import "./KeyPerformanceView.vue?vue&type=style&index=0&id=5756b7d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5756b7d4"]])

export default __exports__